import React, { Component } from 'react';
import moment from 'moment';
import { flowRight as compose } from 'lodash';
import { withRouter } from 'providers';
import { inject, observer } from 'mobx-react';
import { Container, Grid, Box, Menu, MenuItem } from '@mui/material';
import { GetApp as GetAppIcon } from '@mui/icons-material';

import styles from './styles';
import AxlMUISelect from 'AxlMUIComponent/AxlMUISelect';
import JDatePicker from 'components/JDatePicker';

class DispatchSearchFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuElm: null,
    };
  }

  componentDidMount() {
    const { assignmentStore } = this.props.store;
    assignmentStore.loadRegions();
  }

  setDate = (newDate) => {
    const { history, store } = this.props;
    const { assignmentStore } = store;

    const selectedDate = newDate || new Date();

    const day = moment(selectedDate).format('YYYY-MM-DD');
    const region = assignmentStore.regions.length > 0 ? assignmentStore.regions.join(',') : 'all';
    history.push(`/routes/${day}/${region}`);

    assignmentStore.setDate(selectedDate);
  };

  setRegions(regions) {
    const { history, store } = this.props;
    const { assignmentStore } = store;

    const day = assignmentStore.date;
    const region = regions.length > 0 ? regions : [];
    history.push(`/routes/${day}/${region}`);
    assignmentStore.setRegions(region);
  }

  openDownloadMenu = (e) => {
    this.setState({ menuElm: e.currentTarget });
  };

  closeDownloadMenu = () => {
    this.setState({ menuElm: null });
  };

  downloadReport = (name) => {
    const { assignmentStore } = this.props.store;
    const day = assignmentStore.date;
    let url = `${import.meta.env.REACT_APP_API_ROOT}/dsp/reports/${name}?date=${day}`;
    if (assignmentStore.regions.length > 0) {
      url += `&regions=` + assignmentStore.regions.join(',');
    }
    window.open(url, '_blank');
  };

  render() {
    const { menuElm } = this.state;
    const { store } = this.props;

    const { assignmentStore } = store;
    const { date, regions, regionList } = assignmentStore;

    return (
      <Container maxWidth={false} disableGutters sx={styles.container}>
        <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
          <Grid>
            <Grid container spacing={1} alignItems="center" justifyContent="center">
              <Grid>
                <Box>Overview for</Box>
              </Grid>
              <Grid>
                <JDatePicker
                  clear
                  onChange={(d) => this.setDate(d)}
                  value={date ? moment(date) : null}
                  options={{
                    dateFormat: 'MMM DD, YYYY',
                    placeHolder: 'today',
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <Grid container spacing={1} alignItems="center" justifyContent="center">
              <Grid>
                <Box>at</Box>
              </Grid>
              <Grid>
                {regionList.length && (
                  <AxlMUISelect
                    defaultValue={regionList.filter((option) => regions.indexOf(option.value) >= 0)}
                    placeholderButtonLabel="all regions"
                    searchPlaceholder="Search Regions..."
                    placeholder="All regions"
                    placeholderSize={16}
                    options={regionList}
                    onChange={(v) => this.setRegions(v)}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <Box>
              <GetAppIcon onClick={this.openDownloadMenu} color="inherit" sx={styles.downloadIcon} />
              <Menu
                anchorEl={menuElm}
                open={Boolean(menuElm)}
                onClose={this.closeDownloadMenu}
                keepMounted
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              >
                <MenuItem onClick={() => this.downloadReport('detail-tips')}>Monthly Tips - Detail</MenuItem>
                <MenuItem onClick={() => this.downloadReport('total-tips')}>Monthly Tips - Total</MenuItem>
              </Menu>
            </Box>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

const DispatchSearchFilterCompose = compose(inject('store'), observer)(DispatchSearchFilter);

export default withRouter(DispatchSearchFilterCompose);
